import React from "react";

export default function Rating(props: any) {
  if (props.disabledWhenNoRating && !props.rating) {
    return null;
  }

  const getRatingRestToPercentage = () => {
    // Get rest of rating value and convert to percentage
    return (props.rating % 1) * 100;
  };

  return (
    <div className={ `rating-input rating-input--disabled` } >
    { [1, 2, 3, 4, 5].map((rating: number) => {
      return (
        <div
          key={ rating }
          className={ `rating-input__star` }
          id={ `rating-${rating}` }
        >
          <div
            className={ `rating-input__star-inner ${ parseInt(props.rating) >= (rating - 1) ? 'rating-input__star-inner--active' : '' }` }
            style={ parseInt(props.rating) === (rating - 1) ? {
              clipPath: getRatingRestToPercentage() != 0 ? `polygon(0% 0%, ${ getRatingRestToPercentage() }% 0, ${ getRatingRestToPercentage() }% 100%, 0 100%)` : '',
            } : {} }
          />
        </div>
      )
    } ) }
    { props.rating > 0 && (
      <span className="rating-number">({ props.rating })</span>
    ) }
    </div>
  )
}
